exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* -----------------------------------------------------\r\n\t:: Maintenance Page\r\n\t-------------------------------------------------- */\r\nh1.main-maintenance {\r\n  margin-top: 60px;\r\n  color: #fff;\r\n}\r\n\r\nh4.sub-maintenance {\r\n  margin-top: 10px;\r\n  color: #fff;\r\n  font-size: 20px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Work-Local/frontend/src/app/maintenance-mode/maintenance-mode.component.css
// module id = ../../../../../src/app/maintenance-mode/maintenance-mode.component.css
// module chunks = main